<template>
  <div class="cart-table">
    <p v-if="cartStore.products.length === 0" class="text-center h2 mt-7">Your cart is empty!</p>

    <a v-for="(product, index) in cartStore.products" class="cart-row" :href="product.href">
      <div class="img-wrapper">
        <img :src="product.image.thumb" :alt="product.title">
      </div>

      <div class="cart-info-wrapper">
        <div class="cart-info">
          <p class="large">{{ product.title }}</p>
          <p class="xxxsmall fw-light mt-2"><strong>{{ $t('shop.cart.code') }}:</strong> {{ product.code }}</p>
          <p v-if="product?.metal" class="xxxsmall fw-light mt-1"><strong>{{ $t('shop.cart.metal') }}:</strong> {{ product.metal }}</p>
          <p v-if="product?.stone" class="xxxsmall fw-light mt-1"><strong>{{ $t('shop.cart.stone') }}:</strong> {{ product.stone }}</p>
          <p v-if="product?.size" class="xxxsmall fw-light mt-1"><strong>{{ $t('shop.cart.size') }}:</strong> {{ product.size }}</p>
        </div>

        <!-- Actions column -->
        <div class="cart-qty-price">
          <div class="cart-qty">
            <button v-if="product.qty <= 1" @click.stop.prevent="productIdToRemove = product.id; $modal.show('modal-remove-confirm', { backdrop: 'static' });" class="remove-btn" aria-label="Remove">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 51" fill="none">
                <path fill="#ff0008" d="M49.2 6.8H35v-2C35 2.2 32.9.1 30.3.1H19.5c-2.6 0-4.7 2.1-4.7 4.7v2H.5v4.1h4.7v31.8c0 4.1 3.3 7.4 7.4 7.4h24.3c4.1 0 7.4-3.3 7.4-7.4V10.9H49V6.8h.2Zm-30.4-2c0-.4.3-.7.7-.7h10.8c.4 0 .7.3.7.7v2H18.8v-2Zm21.6 37.9c0 1.9-1.5 3.4-3.4 3.4H12.7c-1.9 0-3.4-1.5-3.4-3.4V10.9h31.1v31.8Z" />
                <path fill="#ff0008" d="M27 15.6h-4.1v25.7H27V15.6ZM35.1 15.6H31v25.7h4.1V15.6ZM18.8 15.6h-4.1v25.7h4.1V15.6Z" />
              </svg>
            </button>
            <button v-else @click.stop.prevent="cartStore.decrease(product.id)" class="qty-btn"><span>-</span></button>
            <span class="qty">{{ product.qty }}</span>
            <button @click.stop.prevent="cartStore.increase(product.id)" class="qty-btn"><span>+</span></button>
          </div>

          <div class="ms-3">
            <p v-if="product.initPrice > 0 && product.unit_price < product.initPrice" class="init-price"><span>{{ $c(product.initPrice) }}</span></p>
            <p><span> {{ $c(product.unit_price) }}</span></p>
          </div>
        </div>
      </div>
    </a>
  </div>

  <div v-if="cartStore.products.length" class="cart-total">
    <div class="d-flex align-items-center justify-content-between me-3">
      <p class="large fw-light me-3">{{ $t('shop.cart.total') }}:</p>
      <p class="h2 text-nowrap fw-light">{{ $c(cartStore.total.total_no_extras) }}</p>
    </div>

    <a :href="$root.shopUrls.checkout" class="btn btn-primary btn-outline">{{ $t('shop.cart.checkout') }}</a>
  </div>

  <teleport v-if="$root.mounted" to="#modals">
    <div id="modal-remove-confirm" class="modal fade" aria-labelledby="modal-address-remove-confirm-label" aria-hidden="true" data-bs-backdrop="static">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row bg-lightest pt-sm-10 pb-sm-10 px-sm-8 pt-6 pb-6 px-4">
              <div class="col-16 text-center">
                <h3 class="mb-2">REMOVE PRODUCT</h3>
                <p class="mb-4">Are you sure you want to remove this product?</p>

                <button type="button" class="btn btn-primary btn-outline mx-1" @click="$modal.hide('modal-remove-confirm'); productIdToRemove = null">NO</button>

                <button type="button" class="btn btn-primary btn-outline mx-1" :disabled="false" :class="{ 'loading': false }" @click="handleRemove()">
                  <span>YES</span>
                  <span class="loader"></span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script setup>
import { useCartStore } from './cart-store.js';
const cartStore = useCartStore();
import { ref, inject } from 'vue';
const $notification = inject('$notification');
const $modal = inject('$modal');

cartStore.get();

const productIdToRemove = ref(null);

const handleRemove = async () => {
  cartStore.remove(productIdToRemove.value)
    // .then(response => {})
    .catch((error) => {
      $notification.show({
        class: 'error', // success, warning, error
        title: error?.response?.statusText || error?.name || 'Unknown title',
        status: error?.status?.status || error?.status || 'Unknown status',
        descr: error?.response?.data?.message || error?.message || 'Unknown message',
      });
    })
    .finally(() => {
      $modal.hide('modal-remove-confirm');
    });
}

</script>

<style lang="scss"></style>